import useFiatEnabled from '@/ui/hooks/use-fiat-enabled';
import useFiatWidgetAvailability from '@/ui/hooks/use-fiat-widget-availability';

type BuyAvailability = {
  loading: boolean;
  value: boolean;
};

function useBuyAvailability(): BuyAvailability {
  const { enabled: isFiatEnabled, loading: isFiatLoading } = useFiatEnabled();
  const { available: isFiatWidgetAvailable, loading: isFiatWidgetLoading } =
    useFiatWidgetAvailability();

  return {
    loading: isFiatLoading || isFiatWidgetLoading,
    value: !!isFiatEnabled && isFiatWidgetAvailable,
  };
}

export default useBuyAvailability;
